import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const controlPortReasonMapEntry = z.object({
  redoReason: z.string().trim(),
  controlPortReasonId: z.number().int(),
  controlPortReasonName: z.string(),
});

export const controlPortSettings = defineIntegrationSettings({
  fields: {
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
    returnReasonMap: z.array(controlPortReasonMapEntry),
    defaultReturnReasonId: z.number().int().nullable(),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
